export default "__VITE_ASSET__DE6x24fQ__"